import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';

import { DashboardServiceService } from '@admin/shared/services/dashboard-service.service';

import { AuthenticationService } from '@core/services/auth.service';

import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private socket!: Socket;
  activeWorkspace: any;

  constructor(
    private authService: AuthenticationService,
    private dashboardService: DashboardServiceService
  ) {
    this.dashboardService.getWorkspace().subscribe((workspace) => {
      this.activeWorkspace = workspace;
      this.initializeSocket();
    });
  }

  initializeSocket() {
    this.socket = io(environment.chatSocketURL, {
      query: {
        token: this.authService.getAccessToken(),
        workspaceId: this.activeWorkspace.uuid,
      },
    });
    this.setUpSocket();
  }

  setUpSocket() {
    this.socket.on('connect', () => {
      console.log('Socket.io connection established');
    });

    this.socket.on('connect_error', (error: any) => {
      console.log('Socket.io connection error:', error);
    });

    this.socket.on('disconnect', (reason: string) => {
      console.log('Socket.io connection closed', reason);
    });
  }

  sendEvent(eventName: string, message: any): Observable<any> {
    return new Observable((observer) => {
      const handler = (data: any) => {
        observer.next(data);
      };

      this.socket.emit(eventName, { role: 'user', content: message });
      this.socket.on(eventName, handler);

      return () => {
        this.socket.off(eventName, handler);
      };
    });
  }

  receiveEvent(eventName: string): Observable<any> {
    return new Observable((observer) => {
      const handler = (data: any) => {
        observer.next(data);
      };
      this.socket.on(eventName, handler);
      return () => {
        this.socket.off(eventName, handler);
      };
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      console.log('Socket disconnected');
    }
  }
}
